import { Constants } from "../../../../../../../utils/constants"
import { Frequency } from "../../../../../../../utils/enums/frequency"

export const handleEvery = (frequency?: string | null) => {
    if(frequency && frequency !== Frequency.DAILY) {
        if(frequency === Frequency.WEEKLY) return Constants.week
        else if (frequency === Frequency.MONTH) return Constants.optionByMonth
    }
    else return null
}